<template>
  <div>
    <h3>Onderwijs</h3>
    <table class="table table-condensed">
      <tbody>
        <template v-for="row in rows">
          <tr
            v-if="rowVisible(row)"
            :key="row.title"
          >
            <th>{{ row.title }}</th>
            <td v-html="row.value" />
          </tr>
        </template>
      </tbody>
    </table>
  </div>
</template>

<style scoped>
.ondersteuningsaanbod{
	color: yellow !important;
	font: 1em sans-serif;
	background-color: blue;
	}

</style>
<script>
export default {
  props: {
    school: {
      required: true,
      type: Object,
    },
  },
  data() {
    const { school } = this;

    const nonPOrows = [
      {
        title: 'onderwijsconcept',
        value: school.onderwijsconcept,
      },
	  {
		title: 'aanvulling concept',
		value: school.soort_onderwijs_extra
	  },

      {
        title: 'denominatie',
        value: school.denominatie,
      },
	  {
		title: 'aanbod dyslexie',
		value: ''
	  },
	  {
        title: 'cluster',
        value: school.cluster,
      },
      {
        title: 'specificatie',
        value: school.specificatie,
      },

    ];

    let extraRows = [];
    if (school.type !== 'po') {
      extraRows = nonPOrows;
    }

    return {
      rows: [
        ...extraRows,
        {
          title: 'profielen',
          value: school.profielen, // TODO fix
          show: false,
        },
        {
          title: 'sectoren',
          value: school.sectoren_string,
        },
        {
          title: 'bijzonderheden',
          value: school.onderwijs_bijzonderheden,
        },
        {
          title: 'rooster',
          value: school.rooster,
        },
        {
          title: 'beschrijving',
          value: school.algemene_beschrijving,
        },
        {
          title: 'groepsindeling',
          value: school.groepsindeling,
        },
        {
          title: 'groepsgrootte',
          value: school.groepsgrootte,
        },
        {
          title: 'roostertype',
          value: school.roostertype,
        },
        {
          title: 'begintijd',
          value: school.begintijd,
        },
        {
          title: 'middagpauze',
          value: school.middagpauze,
        },
        {
          title: 'eindtijd lange dag',
          value: school.eindtijd_lange_dag,
        },
        {
          title: 'eindtijd korte dag',
          value: `${school.eindtijd_korte_dag}
          ${school.korte_dag}`,
          show: isset(school.eindtijd_korte_dag),
        },
        {
          title: 'ICT',
          value: school.ict_hardware,
        },
        {
          title: 'leerlingzorg',
          value: school.zorgaanbod,
        },
        {
          title: 'vreemde talen',
          value: school.vreemde_talen,
        },
        {
          title: 'huiswerk',
          value: school.huiswerk,
        },
        {
          title: 'lesmethoden',
          value: school.lesmethoden,
        },
        {
          title: 'schakelklas',
          value: school.schakelklas,
        },
        {
          title: 'meer- en hoogbegaafdheid',
          value: school.hoogbegaafdheid,
        },
        {
          title: 'taalontwikkeling',
          value: school.taalontwikkeling,
        },
        {
          title: 'bewegingsonderwijs',
          value: school.ict_hbewegingsonderwijsardware,
        },
        {
          title: 'brede en/of culturele ontwikkeling',
          value: school.brede_culturele_ontwikkeling,
        },
        {
          title: 'religie en rituelen',
          value: school.religie_rituelen,
        },
        {
          title: 'burgerschap en sociale veiligheid',
          value: school.burgerschap_sociale_veiligheid,
        },
        {
          title: 'overige bijzonderheden',
          value: school.overige_bijzonderheden,
        }
      ],
    };
  },
  methods: {
    rowVisible(row) {
      return row.show === true || (row.show === undefined && row.value);
    },
  },
  mounted() {
	let grouped = {};
	for(let subaanbod of this.school.ondersteunings_subaanbod) {
		if(!grouped[subaanbod.aanbod_id])
			grouped[subaanbod.aanbod_id] = [];

		grouped[subaanbod.aanbod_id].push(subaanbod);
	}

	let index = this.rows.findIndex((element) => element.title == 'aanbod dyslexie');

	this.rows[index].value = this.school.ondersteuningsaanbod.reduce((acc, value) => {
		acc += `<span class="ondersteuningsaanbod">${value.ondersteuningsaanbod}</span><br>`;
				for(let subaanbod of grouped[value.id])
				acc += `<span class="ondersteunings-subaanbod">&nbsp; &nbsp; - ${subaanbod.naam}</span><br>`;

		acc += `<br>`;
		return acc;
	}, '')
  }
};


function isset(value) {
  return !!value;
}

</script>
